module.exports = __webpack_public_path__ + "img/1_1.3b3e3d58.3b3e3d58.gif";